import React, { Component, ReactNode } from 'react'

import { ActivityBar, HamburgerMenu, isPresent } from '../../shared'

import './sidebar.scss'

type Props = {
  children: {
    activity?: ReactNode
    nav: ReactNode | null
  }
}

export const ACTIVE_CLASS_NAME = 'sidebar__button--active'
export const NAVLINK_CLASS_NAME = 'sidebar__button'

export class Sidebar extends Component<Props> {
  render() {
    const {
      children: { nav, activity },
    } = this.props

    return (
      <HamburgerMenu>
        {activity && <ActivityBar>{activity}</ActivityBar>}
        {isPresent(nav) && (
          <div className="sidebar" data-test="sidebar">
            {nav}
          </div>
        )}
      </HamburgerMenu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/sidebar.tsx